<app-scroller-horizontal *ngIf="loaded">
  <button
    class="blank-button filter-value"
    merriNoFocusLink
    [class.selected]="filterValue.selected"
    *ngFor="let filterValue of filterValues"
    (click)="changeFilter(filterValue)"
    appContentChildItem
  >
    <span>{{ filterValue.value }}</span>
    <mat-icon
      *ngIf="filterValue.selected"
      svgIcon="close_small"
    ></mat-icon>
  </button>
</app-scroller-horizontal>
